import { connect } from 'react-redux';
import { push } from "react-router-redux";
import { getUser } from '../redux/actions/AccountSetting';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import LetterGenerate from '../components/LetterGenerate/LetterGenerate';

const mapStateToProps = (state) => {
  return {
    pathname: state.router.location.pathname,
    user: getUserSelector(state),
  };
};

const mapDispatchToProps = dispatch => ({
  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LetterGenerate);



// WEBPACK FOOTER //
// ./src/containers/LetterGenerate.js